/* eslint-disable react/prop-types */
import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Paper,
  Input,
  InputAdornment,
  IconButton,
  NativeSelect,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Chip,
  FormControlLabel,
  Tooltip,
  Button,
  CircularProgress,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import {
  TIPO_DUPLICATA_KEYS,
  nomeTipoDuplicata,
} from '../../../services/ancorasImportacoesTitulosService';
import useStyles from './style';

// "HH:mm:ss" ou "HH:mm" -> "HH:mm" para input type=time
export function toTimeInput(value) {
  if (!value) return '';
  const m = String(value).match(/(\d{2}):(\d{2})/);
  return m ? `${m[1]}:${m[2]}` : '';
}

// "HH:mm" -> "HH:mm:00"
export function toTimeSpanPayload(value) {
  if (!value) return null;
  const s = String(value);
  if (/^\d{2}:\d{2}$/.test(s)) return `${s}:00`;
  if (/^\d{2}:\d{2}:\d{2}$/.test(s)) return s;
  return null;
}

function formatDateTime(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(
    d.getHours(),
  )}:${pad(d.getMinutes())}`;
}

const STATUS_OPTIONS = ['Ativo', 'Inativo'];

/**
 * Form comum entre Register/Edit/Visualize. Layout espelhado do padrao
 * Providers/Provider/registers/BankRegister.js: label + Paper + Input/NativeSelect.
 * - `mode`: 'register' | 'edit' | 'visualize' — controla disabled/branches.
 */
export default function Form({
  mode,
  form,
  onFieldChange,
  perfis,
  todasLojas,
  onToggleTodasLojas,
  lojasKeysArr,
  onChangeLojas,
  lojasCarregadas,
  carregandoLojas,
  onCarregarLojas,
}) {
  const classes = useStyles();
  const isRegister = mode === 'register';
  const isVisualize = mode === 'visualize';
  const disabled = isVisualize;

  const [clientIdLocked, setClientIdLocked] = React.useState(true);
  const [clientSecretLocked, setClientSecretLocked] = React.useState(true);
  const [clientSecretVisible, setClientSecretVisible] = React.useState(false);

  const lojaKeysCarregadasSet = React.useMemo(
    () => new Set((lojasCarregadas || []).map((l) => l.lojaKey)),
    [lojasCarregadas],
  );
  const lojasOrfaosKeys = React.useMemo(
    () => (lojasKeysArr || []).filter((k) => !lojaKeysCarregadasSet.has(k)),
    [lojasKeysArr, lojaKeysCarregadasSet],
  );

  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
          <Typography className={classes.heading}>Informações</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.details}>
          <input
            type="text"
            name="fake-username"
            autoComplete="username"
            tabIndex={-1}
            aria-hidden="true"
            style={{ position: 'absolute', opacity: 0, height: 0, width: 0, border: 0, padding: 0 }}
          />
          <input
            type="password"
            name="fake-password"
            autoComplete="new-password"
            tabIndex={-1}
            aria-hidden="true"
            style={{ position: 'absolute', opacity: 0, height: 0, width: 0, border: 0, padding: 0 }}
          />
          <Grid container>
            <Grid item xs={6}>
              <label className={classes.label}>Apelido</label>
              <Paper className={classes.medium} elevation={0}>
                <Input
                  className={classes.input}
                  classes={{ input: classes.inputText }}
                  placeholder="Apelido"
                  value={form.apelido || ''}
                  disabled={disabled}
                  onChange={(e) => onFieldChange('apelido', e.target.value)}
                  inputProps={{ maxLength: 100 }}
                />
              </Paper>
            </Grid>

            <Grid item xs={6}>
              <label className={classes.label}>Perfil ERP</label>
              <Paper className={classes.medium} elevation={0}>
                <NativeSelect
                  className={classes.input}
                  value={form.importacaoTituloApiErpId || 0}
                  disabled={disabled}
                  onChange={(e) => onFieldChange('importacaoTituloApiErpId', e.target.value)}
                >
                  <option value={0}>FALTA PREENCHER</option>
                  {(perfis || []).map((p) => (
                    <option key={p.importacaoTituloApiErpId} value={p.importacaoTituloApiErpId}>
                      {`${p.erp || ''} v${p.versao || ''}`}
                    </option>
                  ))}
                </NativeSelect>
              </Paper>
            </Grid>

            <Grid item xs={6}>
              <label className={classes.label}>Client Id</label>
              <Paper className={classes.medium} elevation={0}>
                <Input
                  className={classes.input}
                  placeholder={isRegister ? 'Client Id' : '••• mantem o atual se vazio'}
                  value={form.clientId || ''}
                  disabled={disabled}
                  readOnly={clientIdLocked}
                  onFocus={() => setClientIdLocked(false)}
                  onChange={(e) => onFieldChange('clientId', e.target.value)}
                  inputProps={{ maxLength: 200 }}
                  name="bluesoft-client-id"
                  autoComplete="off"
                />
              </Paper>
            </Grid>

            <Grid item xs={6}>
              <label className={classes.label}>Client Secret</label>
              <Paper className={classes.medium} elevation={0}>
                <Input
                  type="text"
                  className={classes.input}
                  inputProps={{
                    style: { WebkitTextSecurity: clientSecretVisible ? 'none' : 'disc' },
                  }}
                  placeholder={isRegister ? 'Client Secret' : '••• mantem o atual se vazio'}
                  value={form.clientSecret || ''}
                  disabled={disabled}
                  readOnly={clientSecretLocked}
                  onFocus={() => setClientSecretLocked(false)}
                  onChange={(e) => onFieldChange('clientSecret', e.target.value)}
                  name="bluesoft-client-secret"
                  autoComplete="off"
                  endAdornment={(
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        tabIndex={-1}
                        onClick={() => setClientSecretVisible((v) => !v)}
                      >
                        {clientSecretVisible ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                      </IconButton>
                    </InputAdornment>
                  )}
                />
              </Paper>
            </Grid>

            <Grid item xs={12}>
              <label className={classes.label}>Tenant (slug do cliente no Bluesoft)</label>
              <Paper className={classes.medium} elevation={0}>
                <Input
                  className={classes.input}
                  classes={{ input: classes.inputLower }}
                  placeholder="ex: proenca-homolog"
                  value={form.tenantSlug || ''}
                  disabled={disabled}
                  onChange={(e) => onFieldChange('tenantSlug', e.target.value)}
                  inputProps={{ maxLength: 100 }}
                />
              </Paper>
              <span className={classes.helper}>
                Aparece no path da URL: https://erp.bluesoft.com.br/&#123;tenant&#125;/api/...
              </span>
            </Grid>

            <Grid item xs={12}>
              <label className={classes.label}>Tipos de Duplicata</label>
              <Paper className={classes.medium} elevation={0} style={{ height: 'auto', minHeight: 44 }}>
                <Select
                  multiple
                  disableUnderline
                  className={classes.input}
                  value={form.tipoDuplicataKeys || []}
                  disabled={disabled}
                  onChange={(e) => onFieldChange('tipoDuplicataKeys', e.target.value)}
                  renderValue={(selected) => (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                      {selected.map((value) => (
                        <Chip
                          key={value}
                          label={`${value} - ${nomeTipoDuplicata(value)}`}
                          size="small"
                        />
                      ))}
                    </div>
                  )}
                >
                  {TIPO_DUPLICATA_KEYS.map((t) => (
                    <MenuItem key={t.id} value={t.id}>
                      <Checkbox checked={(form.tipoDuplicataKeys || []).indexOf(t.id) > -1} />
                      <ListItemText primary={`${t.id} - ${t.nome}`} />
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>

            <Grid item xs={12}>
              <label className={classes.label}>Lojas</label>
              <div className={classes.actionsRow}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!todasLojas}
                      onChange={onToggleTodasLojas}
                      color="primary"
                      disabled={disabled}
                    />
                  }
                  label="Todas as lojas"
                />
                {isRegister ? (
                  <Tooltip title="Salve o vinculo antes de carregar lojas">
                    <span>
                      <Button variant="outlined" disabled>
                        Carregar lojas
                      </Button>
                    </span>
                  </Tooltip>
                ) : (
                  <Button
                    variant="outlined"
                    onClick={onCarregarLojas}
                    disabled={disabled || todasLojas || carregandoLojas}
                    startIcon={carregandoLojas ? <CircularProgress size={16} /> : null}
                  >
                    {carregandoLojas ? 'Carregando...' : 'Carregar lojas'}
                  </Button>
                )}
              </div>
              {!todasLojas && (lojasCarregadas || []).length > 0 && (
                <Paper className={classes.medium} elevation={0} style={{ height: 'auto', minHeight: 44 }}>
                  <Select
                    multiple
                    disableUnderline
                    className={classes.input}
                    value={lojasKeysArr || []}
                    onChange={onChangeLojas}
                    disabled={disabled}
                    renderValue={(selected) => (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                        {selected.map((value) => {
                          const loja = (lojasCarregadas || []).find((l) => l.lojaKey === value);
                          if (!loja) {
                            return (
                              <Tooltip key={value} title="Loja nao encontrada no ERP">
                                <Chip
                                  label={`${value} (?)`}
                                  size="small"
                                  className={classes.orfaoChip}
                                />
                              </Tooltip>
                            );
                          }
                          const nome = loja.nomeFantasia || loja.nomeAbreviado || `Loja ${loja.lojaKey}`;
                          return (
                            <Chip
                              key={value}
                              label={`${nome} (${loja.lojaKey})`}
                              size="small"
                            />
                          );
                        })}
                      </div>
                    )}
                  >
                    {(lojasCarregadas || []).map((l) => {
                      const nome = l.nomeFantasia || l.nomeAbreviado || `Loja ${l.lojaKey}`;
                      return (
                        <MenuItem key={l.lojaKey} value={l.lojaKey}>
                          <Checkbox checked={(lojasKeysArr || []).indexOf(l.lojaKey) > -1} />
                          <ListItemText
                            primary={`${nome} (${l.lojaKey})`}
                            secondary={l.razaoSocial}
                          />
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Paper>
              )}
              {!todasLojas &&
                (lojasCarregadas || []).length === 0 &&
                (lojasKeysArr || []).length > 0 && (
                  <div className={classes.chipsBox}>
                    {lojasKeysArr.map((k) => (
                      <Tooltip
                        key={k}
                        title="Loja nao carregada — clique em 'Carregar lojas' para revisar"
                      >
                        <Chip label={`${k} (?)`} size="small" className={classes.orfaoChip} />
                      </Tooltip>
                    ))}
                  </div>
                )}
              {!todasLojas && lojasOrfaosKeys.length > 0 && (lojasCarregadas || []).length > 0 && (
                <span className={classes.helper}>
                  {lojasOrfaosKeys.length} loja(s) selecionada(s) nao foram encontradas no ERP —
                  revise manualmente.
                </span>
              )}
            </Grid>

            <Grid item xs={4}>
              <label className={classes.label}>Horário Geração Full</label>
              <Paper className={classes.medium} elevation={0}>
                <Input
                  type="time"
                  className={classes.input}
                  value={form.horarioGeracaoFull || ''}
                  disabled={disabled}
                  onChange={(e) => onFieldChange('horarioGeracaoFull', e.target.value)}
                  inputProps={{ step: 60 }}
                />
              </Paper>
            </Grid>

            <Grid item xs={4}>
              <label className={classes.label}>Horário Geração Complementar</label>
              <Paper className={classes.medium} elevation={0}>
                <Input
                  type="time"
                  className={classes.input}
                  value={form.horarioGeracaoComplementar || ''}
                  disabled={disabled}
                  onChange={(e) => onFieldChange('horarioGeracaoComplementar', e.target.value)}
                  inputProps={{ step: 60 }}
                />
              </Paper>
            </Grid>

            <Grid item xs={4}>
              <label className={classes.label}>Intervalo Mínimo (minutos)</label>
              <Paper className={classes.medium} elevation={0}>
                <Input
                  type="number"
                  className={classes.input}
                  placeholder="Intervalo em minutos"
                  value={
                    form.intervaloMinimoMinutos === null ||
                    form.intervaloMinimoMinutos === undefined
                      ? ''
                      : form.intervaloMinimoMinutos
                  }
                  disabled={disabled}
                  onChange={(e) => onFieldChange('intervaloMinimoMinutos', e.target.value)}
                  inputProps={{ min: 0 }}
                />
              </Paper>
            </Grid>

            <Grid item xs={4}>
              <label className={classes.label}>Status</label>
              <Paper className={classes.medium} elevation={0}>
                <NativeSelect
                  className={classes.input}
                  value={form.status || 'Ativo'}
                  disabled={disabled}
                  onChange={(e) => onFieldChange('status', e.target.value)}
                >
                  {STATUS_OPTIONS.map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
                </NativeSelect>
              </Paper>
            </Grid>

            <Grid item xs={4}>
              <label className={classes.label}>Baixa de Títulos Antecipados</label>
              <div className={classes.actionsRow}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!form.enviarBaixaTitulosAntecipados}
                      onChange={(e) =>
                        onFieldChange('enviarBaixaTitulosAntecipados', e.target.checked)
                      }
                      color="primary"
                      disabled={disabled}
                    />
                  }
                  label="Enviar baixa ao ERP"
                />
              </div>
            </Grid>

            {!isRegister && (
              <>
                <Grid item xs={4}>
                  <label className={classes.label}>Última Geração Full</label>
                  <Paper className={classes.medium} elevation={0}>
                    <Input
                      className={classes.input}
                      value={formatDateTime(form.dataUltimaGeracaoFull)}
                      readOnly
                      disabled
                    />
                  </Paper>
                </Grid>
                <Grid item xs={4}>
                  <label className={classes.label}>Última Geração Complementar</label>
                  <Paper className={classes.medium} elevation={0}>
                    <Input
                      className={classes.input}
                      value={formatDateTime(form.dataUltimaGeracaoComplementar)}
                      readOnly
                      disabled
                    />
                  </Paper>
                </Grid>
              </>
            )}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </>
  );
}
